import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';

import Login from './pages/Login';
import StudentJoin from './pages/StudentJoin';
import Dashboard from './pages/Dashboard';
import GamePackBuilder from './pages/GamePackBuilder';
import TeacherHost from './pages/TeacherHost';
import StudentGame from './pages/StudentGame';
import ReviewGame from './pages/ReviewGame';

// Protected Route pro učitele
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-white text-xl">Načítání...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SocketProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Login />} />
            <Route path="/student" element={<StudentJoin />} />

            {/* Protected teacher routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gamepack/new"
              element={
                <ProtectedRoute>
                  <GamePackBuilder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gamepack/edit/:id"
              element={
                <ProtectedRoute>
                  <GamePackBuilder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/host"
              element={
                <ProtectedRoute>
                  <TeacherHost />
                </ProtectedRoute>
              }
            />
            <Route
              path="/review/:id"
              element={
                <ProtectedRoute>
                  <ReviewGame />
                </ProtectedRoute>
              }
            />

            {/* Student game route */}
            <Route path="/game/:roomCode" element={<StudentGame />} />

            {/* 404 */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </SocketProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
